import React from 'react';

import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import { ChartContainer, ChartTitle } from './styles';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const CHART_COLORS = ['#8DC0BA', '#7E5FB1', '#B15FA4', '#73A4F7', '#E3D193', '#F7A473', '#93E3B1', '#D193E3'];

const NoVisitReasonsChart = ({ data = [] }) => {
    const chartData = {
        labels: data.map((item) => item.label),
        datasets: [
            {
                data: data.map((item) => item.value),
                backgroundColor: data.map((_, index) => CHART_COLORS[index % CHART_COLORS.length]),
                borderWidth: 0
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right',
                labels: {
                    usePointStyle: true,
                    pointStyle: 'circle',
                    padding: 15,
                    font: {
                        size: 14,
                        weight: 600
                    }
                }
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const percentage = ((context.raw / total) * 100).toFixed(1);
                        return `${context.label}: ${percentage}%`;
                    }
                }
            },
            datalabels: {
                color: '#000',
                font: {
                    weight: 'bold',
                    size: 14
                },
                formatter: (value, context) => {
                    const total = context.dataset.data.reduce((a, b) => a + b, 0);
                    const percentage = ((value / total) * 100).toFixed(2);
                    return `${percentage}%`;
                }
            }
        }
    };

    if (!data || data.length === 0) {
        return (
            <ChartContainer>
                <ChartTitle>Motivos de não visita</ChartTitle>
                <div style={{ height: '250px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ color: '#999' }}>Nenhum registro de ausência no período</span>
                </div>
            </ChartContainer>
        );
    }

    return (
        <ChartContainer>
            <ChartTitle>Motivos de não visita</ChartTitle>
            <div style={{ height: '250px' }}>
                <Pie data={chartData} options={options} />
            </div>
        </ChartContainer>
    );
};

export default NoVisitReasonsChart;
